import { render, staticRenderFns } from "./ManagePerson.vue?vue&type=template&id=78463d5c&scoped=true"
import script from "./ManagePerson.vue?vue&type=script&lang=js"
export * from "./ManagePerson.vue?vue&type=script&lang=js"
import style0 from "./ManagePerson.vue?vue&type=style&index=0&id=78463d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78463d5c",
  null
  
)

export default component.exports